import type { SessionSummary } from '@/types/training';
import { Observable } from './observable';

/**
 * The session that just finished, handed to the completion screen.
 *
 * Kept in a module-level store rather than router state so that a reload on
 * `/session/complete` degrades to an empty state instead of throwing, and so
 * the summary survives the navigation without being serialised into the URL.
 */
export const lastSession = new Observable<SessionSummary | null>(null);
